import React, { useCallback, useState } from 'react'
import _ from 'lodash'

import AccommodationModal from '../AccommodalModal/AccommodationModal'
import NorthstarAccommodationModal from '../AccommodalModal/AccommodationDetailsModal'
import { onEnter } from '../../utilities/accessibility/onEnter'
import { removeEscapedHTML } from '../../utilities/content/html'

import '../../styles/scss/components/accommodation-card.scss'

const AccommodationCard = ({ accommodation }) => {
  const [modalOpen, setModalOpen] = useState(false)
  const [windowOffset, setWindowOffset] = useState(0)

  function formatDescriptionForCard(cardDescription) {
    let description = cardDescription && removeEscapedHTML(cardDescription)
    if (description && description.length > 265) {
      // quick and easy hack to remove line breaks
      description = description.replaceAll('<br /><br />', ' ')
      description = description.replaceAll('<br />', ' ')
      return `${description.replace(/^(.{265}[^\s]*).*/, '$1')} ...`
    }
    return description
  }

  const toggleModal = useCallback(() => {
    if (modalOpen) {
      document.body.setAttribute('style', '')
      window.scrollTo(0, windowOffset)
    } else {
      setWindowOffset(window.scrollY)
      document.body.setAttribute('style', `overflow: hidden;`)
    }
    setModalOpen(!modalOpen)
  }, [modalOpen, windowOffset])

  const cardImage = _.get(accommodation, 'viewExtensions.images[0].url')
  const cardDescription = _.get(accommodation, 'description')
    || _.get(accommodation, 'viewExtensions.northstar.HotelDescription')
  const Modal = !_.isEmpty(_.get(accommodation, 'viewExtensions.northstar'))
      ? NorthstarAccommodationModal
      : AccommodationModal
  const displayItineraryFlag = _.get(accommodation, 'viewExtensions.itineraryFlag')
  const itineraryFlagText = _.get(accommodation, 'viewExtensions.itineraryText')

  return (
    <>
      <div
        className="accommodation-card"
        onClick={toggleModal}
        onKeyDown={(event) => onEnter(event, toggleModal)}
        role="button"
        tabIndex="0"
      >
        <div
          className="u-flex accommodation-card__hero"
          style={{
            backgroundImage: `url("${cardImage}")`,
          }}
        >
          {displayItineraryFlag && (
            <span className="accommodation-card__hero__banner">
              {itineraryFlagText}
            </span>
          )}
          <div className="accommodation-card__hero__gradient" />
          <span className="u-flex-align-self-end accommodation-card__hero__title">
            {_.get(accommodation, 'name')}
          </span>
        </div>
        <div className="u-flex u-flex-column u-flex-space-between accommodation-card__content">
          <p>
            {formatDescriptionForCard(cardDescription)}
          </p>
          <span className="u-flex accommodation-card__content__learn-more">
            Learn More
          </span>
        </div>
      </div>
      <Modal
        accommodation={accommodation}
        isOpen={modalOpen}
        onClose={toggleModal}
      />
    </>
  )
}

export default AccommodationCard
